import * as Constants from './Constants';

const cbandNodes = {
  initiateCBandRepair: null,
  errorMessage: null,
  cbandAuthToken: null,
  load5gOrder: null,
  checkEligiblity: null,
  inspecioTocken: null,
  inspecioEmailResponse: null,
  inspecioReviewOrderResponse: null,
  validatePin: null,
  validateOrder: null,
  validateCart: null,
  retriveCart: null,
  updateCart: null,
  termandConditions: null,
  submitOrders: null,
  orderConfirmations: null,
  cbandPin: null,
  assignMTN: null,
  retriveNPAN: null,
  signatureData: null,
  signatureSubmitSuccessData: null,
  landingPageSelection: '',
  isSLinkInspoioCalled: null,
  isSLinkErrorInspoioCalled: null,
  forgetPinEmailResponse: null,
  validateEmailOtp: null,
  validateEmailOtpFailure: null,
  emailOtpSuccess: null,
  emailOtpFailure: null,
  verifyAuthCodeResponse: null,
  otpInspecioSuccess: null,
  otpInspecioFailure: null,
  retriveNPANFail: null,
  inspecioSumbitOrderPageResponse: null,
  isTandCDeclined: null,
  otpGenerationInspecioSuccess: null,
  showForgetOption: null,
  creditHold: null,
  validatePinFail: null,
};

const techCBand = (state = cbandNodes, action) => {
  switch (action.type) {
    case Constants.INITIATE_C_BAND_REPAIR_SUCCESS:
      return { ...state, initiateCBandRepair: action.response };
    case Constants.INITIATE_C_BAND_REPAIR_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.C_BAND_AUTH_TOKEN_SUCCESS:
      return { ...state, cbandAuthToken: action.response };
    case Constants.C_BAND_AUTH_TOKEN_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.C_BAND_LOAD_5G_ORDER_SUCCESS:
      return { ...state, load5gOrder: action.response };
    case Constants.C_BAND_LOAD_5G_ORDER_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.C_BAND_CHECKELIGIBLITY_SUCCESS:
      return { ...state, checkEligiblity: action.response };
    case Constants.C_BAND_CHECKELIGIBLITY_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.GET_C_BAND_INSPECIO_TOCKEN:
      return { ...state, inspecioTocken: action.response };
    case Constants.GET_C_BAND_INSPECIO_TOCKEN_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.SEND_C_BAND_INSPECIO_EMAIL:
      return { ...state, inspecioReviewOrderResponse: action.response };
    case Constants.SEND_C_BAND_INSPECIO_EMAIL_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.SEND_C_BAND_INSPECIO_MESSAGE:
      return { ...state, inspecioEmailResponse: action.response };
    case Constants.SEND_C_BAND_INSPECIO_MESSAGE_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_SUCCESS:
      return { ...state, inspecioSumbitOrderPageResponse: action.response };
    case Constants.SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_VALIDATECART_SUCCESS:
      return { ...state, validateCart: action.response };
    case Constants.TECH_VALIDATECART_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_RETRIVECART_SUCCESS:
      return { ...state, retriveCart: action.response };
    case Constants.TECH_RETRIVECART_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_UPDATECART_SUCCESS:
      return { ...state, updateCart: action.response };
    case Constants.TECH_UPDATECART_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_VALIDATEORDER_SUCCESS:
      return { ...state, validateOrder: action.response };
    case Constants.TECH_VALIDATEORDER_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_TERMAANDCONDITIONS_SUCCESS:
      return { ...state, termandConditions: action.response };
    case Constants.TECH_TERMAANDCONDITIONS_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_SUBMIT_ORDER_SUCCESS:
      return { ...state, submitOrders: action.response };
    case Constants.TECH_SUBMIT_ORDER_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.TECH_ORDER_CONFIRMATION_SUCCESS:
      return { ...state, orderConfirmations: action.response };
    case Constants.TECH_ORDER_CONFIRMATION_FAIL:
      return { ...state, errorMessage: action.errorMessage };
    case Constants.C_BAND_VALIDATE_PIN_SUCCESS:
      return { ...state, validatePin: action.response };
    case Constants.C_BAND_VALIDATE_PIN_FAIL:
      return { ...state, validatePinFail: action.response };
    case Constants.VERIFIED_PIN_CBAND:
      return { ...state, verifiedPin: action.response };
    case 'FETCH_TECH_CBAND_PIN':
      return { ...state, cbandPin: action.response };
    case Constants.FETCH_TECH_CBAND_CREDIT_HOLD: return { ...state, creditHold: action.response };
    case Constants.ASSIGN_MTN_SUCCESS: return { ...state, assignMTN: action.response };
    case Constants.RETREIVE_NPAN_SUCCESS: return { ...state, retriveNPAN: action.response };
    case Constants.RETREIVE_NPAN_FAIL: return { ...state, retriveNPANFail: action.errorMessage };
    case Constants.UPDATE_TECH_TOS_SIGNATURE: return { ...state, signatureData: action.response };
    case Constants.CAPTURE_SIGNATURE_SUCCESS: return { ...state, signatureSubmitSuccessData: action.response };
    case 'SEND_LINK_INSPICIO_CALLED': return { ...state, isSLinkInspoioCalled: action.data };
    case 'TECH_CBD_VERIFY_EMAIL': return { ...state, forgetPinEmailResponse: action.response || action.data };
    case 'TECH_CBD_VERIFY_AUTH_CODE': return { ...state, verifyAuthCodeResponse: action.response || action.data };
    case Constants.TECH_CBD_SEND_OTP_EMAIL_SUCCESS: return { ...state, emailOtpSuccess: action.response };
    case Constants.TECH_CBD_SEND_OTP_EMAIL_FAIL: return { ...state, emailOtpFailure: action.errorMessage };
    case Constants.TECH_CBD_VALIDATE_OTP_SUCCESS: return { ...state, validateEmailOtp: action.response };
    case Constants.TECH_CBD_VALIDATE_OTP_FAIL: return { ...state, validateEmailOtpFailure: action.errorMessage };
    case Constants.INSPECIO_TECH_CBD_VALIDATE_OTP_SUCCESS: return { ...state, otpInspecioSuccess: action.response };
    case Constants.INSPECIO_TECH_CBD_VALIDATE_OTP_FAIL: return { ...state, otpInspecioFailure: action.errorMessage };
    case Constants.POST_SEND_LINK_ERROR_MESSAGE_SUCCESS: return { ...state, isSLinkErrorInspoioCalled: action.data };
    case 'TECH_CBD_TERMS_AND_CONDITION_DECLINED': return { ...state, isTandCDeclined: action.response || action.data };
    case Constants.INSPECIO_TECH_CBD_GENERATE_OTP_SUCCESS: return { ...state, otpGenerationInspecioSuccess: action.response };
    case Constants.INSPECIO_TO_SHOW_FORGET_OPT_SUCCESS: return { ...state, showForgetOption: action.response };
    case Constants.INSPECIO_TO_SHOW_FORGET_OPT_FAIL: return { ...state, errorMessage: action.errorMessage };
    case Constants.LANDING_PAGE_SELECTION:
      return { ...state, landingPageSelection: action.data };
    case Constants.STATE_INTIALIZE:
      return cbandNodes;

    default: return state;
  }
};
export default techCBand;
